@layer reset, default, disabled, error, focus;

@layer reset {
  :host {
    display: block;

    .gcds-select-wrapper {
      margin: 0;
      padding: 0;
      border: 0;

      select {
        box-sizing: border-box;
      }

      slot {
        display: initial;
      }
    }
  }
}

@layer default {
  :host .gcds-select-wrapper {
    max-width: 75ch;
    font: var(--gcds-select-font-desktop);
    color: var(--gcds-select-default-text);
    transition: color ease-in-out 0.15s;

    @media only screen and (width < 48em) {
      font: var(--gcds-select-font-mobile);
    }

    select {
      display: block;
      min-width: var(--gcds-select-min-width-and-height);
      max-width: 100%;
      height: auto;
      min-height: var(--gcds-select-min-width-and-height);
      font: inherit;
      margin: var(--gcds-select-margin) !important;
      padding: var(--gcds-select-padding) !important;
      background-color: var(--gcds-select-default-background);
      color: var(--gcds-select-default-text);
      border: var(--gcds-select-border-width) solid currentColor;
      border-radius: var(--gcds-select-border-radius);
      box-sizing: border-box;
      transition: all ease-in-out 0.15s;

      /* Select arrow */
      -webkit-appearance: none;
      -moz-appearance: none;
      background-image: url("data:image/svg+xml;utf8,<svg width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.799988 0.900024L7.79999 7.90003L14.8 0.900024' stroke='currentColor' stroke-width='2'/></svg>");
      background-repeat: no-repeat;
      background-position-x: var(--gcds-select-arrow-position-x);
      background-position-y: 50%;
    }
  }
}

@layer disabled {
  :host .gcds-select-wrapper.gcds-disabled {
    color: var(--gcds-select-disabled-text);

    gcds-label {
      --gcds-label-text: currentColor;
    }

    gcds-hint {
      --gcds-hint-text: currentColor;
    }

    select:disabled {
      cursor: not-allowed;
      background-color: var(--gcds-select-disabled-background);
      border-color: var(--gcds-select-disabled-text);
    }
  }
}

@layer error {
  :host .gcds-select-wrapper.gcds-error:not(:focus-within) select {
    border-color: var(--gcds-select-danger-border);
  }
}

@layer focus {
  :host .gcds-select-wrapper:focus-within select:focus {
    border-color: var(--gcds-select-focus-border);
    outline: var(--gcds-select-outline-width) solid
      var(--gcds-select-focus-border);
    outline-offset: var(--gcds-select-border-width);
    box-shadow: var(--gcds-select-focus-box-shadow);
  }
}
